module.exports = require("vuetify/lib/components/VSnackbar");